import get from 'lodash/get';

import GreetingDisabled from 'src/images/GreetingDisabled.svg';
import GreetingDisabledQuickReply from 'src/images/GreetingDisabled-QuickReply.svg';
import OnboardingEnabledEmailName from 'src/images/OnboardingEnabled-EmailName.svg';
import OnboardingEnabledNameEmail from 'src/images/OnboardingEnabled-NameEmail.svg';
import OnboardingEnabledEmailNameQuickReply from 'src/images/OnboardingEnabled-EmailName-QuickReply.svg';
import OnboardingEnabledNameEmailQuickReply from 'src/images/OnboardingEnabled-NameEmail-QuickReply.svg';
import MobileGreetingDisabled from 'src/images/MobileGreetingDisabled.svg';
import MobileGreetingDisabledQuickReply from 'src/images/MobileGreetingDisabled-QuickReply.svg';
import MobileOnboardingEnabledEmailName from 'src/images/MobileOnboardingEnabled-EmailName.svg';
import MobileOnboardingEnabledNameEmail from 'src/images/MobileOnboardingEnabled-NameEmail.svg';
import MobileOnboardingEnabledEmailNameQuickReply from 'src/images/MobileOnboardingEnabled-EmailName-QuickReply.svg';
import MobileOnboardingEnabledNameEmailQuickReply from 'src/images/MobileOnboardingEnabled-NameEmail-QuickReply.svg';
import { FIELDS_MAPPER, ONBOARDING_PROMPT_ORDER } from 'src/presentation/components/pages/chat/chatConstants';

const webEmailOrNameSvgMap = {
  EMAIL: {
    ['QUICK_REPLY_RESPONSE']: OnboardingEnabledEmailNameQuickReply,
    ['TEXT']: OnboardingEnabledEmailName,
  },
  NAME: {
    ['QUICK_REPLY_RESPONSE']: OnboardingEnabledNameEmailQuickReply,
    ['TEXT']: OnboardingEnabledNameEmail,
  },
};

const mobileEmailOrNameSvgMap = {
  EMAIL: {
    ['QUICK_REPLY_RESPONSE']: MobileOnboardingEnabledEmailNameQuickReply,
    ['TEXT']: MobileOnboardingEnabledEmailName,
  },
  NAME: {
    ['QUICK_REPLY_RESPONSE']: MobileOnboardingEnabledNameEmailQuickReply,
    ['TEXT']: MobileOnboardingEnabledNameEmail,
  },
};

export const getSvgImage = ({ workingState, isMobile }) => {
  const onboardingEnabled = get(workingState, FIELDS_MAPPER.ONBOARDING_ENABLED.path, false);
  const userResponseType = get(workingState, FIELDS_MAPPER.ONBOARDING_RESPONSE_TYPE.path, 'TEXT');

  if (!onboardingEnabled) {
    switch (userResponseType) {
      case 'QUICK_REPLY_RESPONSE':
        return isMobile ? MobileGreetingDisabledQuickReply : GreetingDisabledQuickReply;
      case 'TEXT':
        return isMobile ? MobileGreetingDisabled : GreetingDisabled;
    }
  }

  const onboardingCompositionStage = get(
    workingState,
    FIELDS_MAPPER.ONBOARDING_COMPOSITION_STAGE.path,
    ONBOARDING_PROMPT_ORDER[0]
  );

  const emailOrNameSvgMap = isMobile ? mobileEmailOrNameSvgMap : webEmailOrNameSvgMap;

  return emailOrNameSvgMap[onboardingCompositionStage][userResponseType];
};
